import type { Sector } from "@/types/risk-analysis";
import type {
  WizardMainStep,
  WizardSectorStep,
  WizardSteps,
  WizardStepType,
} from "@/types/risk-wizard";

const MAIN_STEP_DEFINITIONS: readonly {
  id: number;
  type: WizardStepType;
  label: string;
}[] = [
  { id: 1, type: "sector-selection", label: "Selectare sectoare" },
  { id: 2, type: "sector-matrix", label: "Matrice risc" },
  { id: 3, type: "review", label: "Revizuire" },
  { id: 4, type: "generate-report", label: "Generare raport" },
] as const;

export function buildWizardSteps(
  selectedSectorIds: string[],
  sectors: Sector[]
): WizardSteps {
  const sectorMap = new Map(sectors.map((s) => [s.id, s]));

  const seen = new Set<string>();
  const sectorSteps: WizardSectorStep[] = [];

  for (const id of selectedSectorIds) {
    if (seen.has(id)) continue;
    seen.add(id);

    const sector = sectorMap.get(id);
    if (!sector) continue;

    sectorSteps.push({
      sectorId: sector.id,
      sectorCode: sector.cod,
      sectorName: sector.nume,
      status: "pending",
    });
  }

  const mainSteps: WizardMainStep[] = MAIN_STEP_DEFINITIONS.map(
    (def, index) => ({
      ...def,
      status: index === 0 ? "current" : "upcoming",
    })
  );

  return {
    mainSteps,
    sectorSteps,
    currentMainStep: 1,
    currentSectorIndex: 0,
  };
}
